import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from '../orders-new/models/order.dto';

@Injectable({ providedIn: 'root' })
export class OrdersBoardProvider {
  constructor(private http: HttpClient) {}

  getOrders(): Observable<Order[]> {
    const url = `/api/production-orders`;
    return this.http.get<Order[]>(url);
  }
}
